import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function Icon({icon, style}) {
    return <FontAwesomeIcon style={style} icon={icon}></FontAwesomeIcon>
}